<template>
    <div>
        <h3>Pessoa(s) para transferir</h3>
        <table class="b-table table table-striped b-table-stacked-md">
            <thead>
                <tr>
                    <th>Nome completo</th>
                    <th>Idade</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="pessoa in selecteds" :key="pessoa.id">
                    <td>{{ pessoa.nome_completo }}</td>
                    <td>{{ pessoa.idade }} ano(s)</td>
                </tr>
            </tbody>
        </table>
        <div class="row">
            <h3 class="col-12">Buscar por Código familiar / NIS ou CPF</h3>
        </div>
        <form class="row" @submit.prevent="buscarFamilia">
            <form-select
                :required="true"
                v-model="tipobusca"
                :itens="tipos"
                label="Opção"
                grid="5"
            />
            <form-input
                :required="true"
                v-model="itembusca"
                label="Número"
                grid="5"
            />
            <div class="col-md-2 pt-3">
                <button
                    class="btn mt-1 btn-block btn-sm btn-success"
                    type="submit"
                >
                    Buscar
                </button>
            </div>
        </form>
        <load v-if="loadingSearch" mode="table" />
        <div class="row mt-2" v-if="familiaSelected != ''">
            <h4 class="col-12">Dados da familia de destino</h4>
            <div class="col-12">
                <table class="b-table table table-striped b-table-stacked-md">
                    <thead>
                        <tr>
                            <th>Código familia</th>
                            <th>Data Inclusão</th>
                            <th>Data Atualização</th>
                            <th>Estado cadastral</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ familiaSelected.codigo_familiar }}</td>
                            <td>{{ familiaSelected.data_cadastramento }}</td>
                            <td>{{ familiaSelected.data_atualizacao }}</td>
                            <td v-html="familiaSelected.estado_cadastral"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h4 class="col-12">Membros da Familia</h4>
            <div class="col-12">
                <table class="b-table table table-striped b-table-stacked-md">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Nome mãe</th>
                            <th>Nome Pai</th>
                            <th>Posição Familiar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="familiar in familiaSelected.familiares"
                            :key="familiar.id"
                        >
                            <td>{{ familiar.nome_completo }}</td>
                            <td>{{ familiar.mae }}</td>
                            <td>{{ familiar.pai }}</td>
                            <td>
                                <span
                                    v-for="posicao in $root.arrays
                                        .posicao_familiar"
                                    :key="posicao.id"
                                >
                                    <span
                                        v-if="
                                            posicao.id ==
                                                familiar.posicao_familiar
                                        "
                                    >
                                        {{ posicao.value }}
                                    </span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="alert alert-warning p-1" v-if="empty">
            <i class="mdi mdi-alert mdi-24px mr-1"></i> Nenhuma familia foi
            encontrada.
        </div>
    </div>
</template>
<script>
export default {
    props: ["pessoas", "selecteds"],
    data() {
        return {
            familiaSelected: "",
            tipos: [
                { id: "codigo", value: "Código familiar" },
                { id: "nis", value: "NIS" },
                { id: "cpf", value: "CPF" }
            ],
            tipobusca: "",
            itembusca: "",
            loadingSearch: false,
            empty: false
        };
    },
    methods: {
        buscarFamilia() {
            this.loadingSearch = true;
            this.empty = false;
            this.familiaSelected = [];
            axios
                .post("api/dashboard/familias/search", {
                    tipo: this.tipobusca,
                    termo: this.itembusca
                })
                .then(response => {
                    this.loadingSearch = false;
                    if (response.data.data) {
                        this.familiaSelected = response.data.data;
                        this.$emit("selecionada", this.familiaSelected);
                    } else {
                        this.empty = true;
                        this.$emit("vazio");
                    }
                });
        }
    }
};
</script>
